import { render, staticRenderFns } from "./IncomingCampaignsTabs.vue?vue&type=template&id=19185dfc&scoped=true"
import script from "./IncomingCampaignsTabs.vue?vue&type=script&lang=ts"
export * from "./IncomingCampaignsTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19185dfc",
  null
  
)

export default component.exports